import api from "../api";

export const purchaseApi = {
  /* =========================================================
     PROJECTS
  ========================================================= */
  projects: {
    list: (params = {}) =>
      api.get("/projects", { params }),
  },

  /* =========================================================
     FINANCE MASTERS
  ========================================================= */
  financeMasters: {
    list: () =>
      api.get("/finance-masters"),

    add: (key, value) =>
      api.post(
        `/finance-masters/${encodeURIComponent(key)}`,
        { value }
      ),

    remove: (key, value) =>
      api.delete(
        `/finance-masters/${encodeURIComponent(key)}`,
        {
          data: { value },
        }
      ),

    syncAll: (data) =>
      api.post("/finance-masters/sync/all", data),
  },

  /* =========================================================
     VENDORS
  ========================================================= */
  vendors: {
    list: (params = {}) =>
      api.get("/purchase/vendors", { params }),

    get: (id) =>
      api.get(`/purchase/vendors/${id}`),

    create: (data) =>
      api.post("/purchase/vendors", data),

    update: (id, data) =>
      api.put(`/purchase/vendors/${id}`, data),

    remove: (id) =>
      api.delete(`/purchase/vendors/${id}`),
  },

  /* =========================================================
     QUOTATIONS
  ========================================================= */
  quotations: {
    list: (params = {}) =>
      api.get("/purchase/quotations", {
        params,
      }),

    get: (id) =>
      api.get(`/purchase/quotations/${id}`),

    create: (data) =>
      api.post("/purchase/quotations", data),

    update: (id, data) =>
      api.put(`/purchase/quotations/${id}`, data),

    remove: (id) =>
      api.delete(`/purchase/quotations/${id}`),

    openFile: (fileName) =>
      api.get(
        `/purchase/quotations/file/${encodeURIComponent(
          fileName
        )}`,
        {
          responseType: "blob",
        }
      ),
  },

  /* =========================================================
     PROFORMA INVOICES
  ========================================================= */
  proformaInvoices: {
    list: (params = {}) =>
      api.get(
        "/purchase/proforma-invoices",
        {
          params,
        }
      ),

    get: (id) =>
      api.get(
        `/purchase/proforma-invoices/${id}`
      ),

    create: (data) =>
      api.post(
        "/purchase/proforma-invoices",
        data
      ),

    update: (id, data) =>
      api.put(
        `/purchase/proforma-invoices/${id}`,
        data
      ),

    remove: (id) =>
      api.delete(
        `/purchase/proforma-invoices/${id}`
      ),

    openFile: (fileName) =>
      api.get(
        `/purchase/proforma-invoices/file/${encodeURIComponent(
          fileName
        )}`,
        {
          responseType: "blob",
        }
      ),
  },

  /* =========================================================
     PURCHASE INVOICES
  ========================================================= */
  invoices: {
    list: (params = {}) =>
      api.get(
        "/purchase/invoices",
        {
          params,
        }
      ),

    get: (id) =>
      api.get(
        `/purchase/invoices/${id}`
      ),

    create: (data) =>
      api.post(
        "/purchase/invoices",
        data
      ),

    update: (id, data) =>
      api.put(
        `/purchase/invoices/${id}`,
        data
      ),

    remove: (id) =>
      api.delete(
        `/purchase/invoices/${id}`
      ),

    addPayment: (id, data) =>
      api.post(
        `/purchase/invoices/${id}/payments`,
        data
      ),

    openFile: (fileName) =>
      api.get(
        `/purchase/invoices/file/${encodeURIComponent(
          fileName
        )}`,
        {
          responseType: "blob",
        }
      ),
  },
};